
import { ModalTemplateCleanComponent } from './modal-template-clean/modal-template-clean.component';
import { ModalTemplateDefaultComponent } from './modal-template-default/modal-template-default.component';
import { ModalTemplateNoCloseComponent } from './modal-template-no-close/modal-template-no-close.component';
import { ModalLowBalanceComponent } from './modal-low-balance/modal-low-balance.component';
import { ModalTemplateBorderImageComponent } from './modal-template-border-image/modal-template-border-image.component';

export const ModalTemplateListImports = [
  ModalTemplateDefaultComponent,
  ModalTemplateNoCloseComponent,
  ModalLowBalanceComponent,
  ModalTemplateCleanComponent,
  ModalTemplateBorderImageComponent
];

export const ModalTemplate = {
  DEFAULT: ModalTemplateDefaultComponent,
  NO_CLOSE: ModalTemplateNoCloseComponent,
  LOW_BALANCE: ModalLowBalanceComponent,
  CLEAR: ModalTemplateCleanComponent,
  BORDER_IMAGE: ModalTemplateBorderImageComponent
};

export type ModalTemplateType = keyof typeof ModalTemplate;
